'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

require('../../src/styles/style.scss');

var _doctifyWfCarousel = require('./doctify-wf-carousel');

var _doctifyWfCarousel2 = _interopRequireDefault(_doctifyWfCarousel);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
    messages = require('./../../src/lang/' + localeBase + '.json');
} catch (error) {
    messages = require('./../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var WfCarouselWidget = function WfCarouselWidget(props) {
    var href = props.link || props.profileId && props.profileType && props.baseUrl + '/' + props.profileType.slice(0, -1) + '/' + props.profileId;
    return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: localeBase, messages: messages },
        _react2.default.createElement(_doctifyWfCarousel2.default, (0, _extends3.default)({}, props, { href: href }))
    );
};

WfCarouselWidget.displayName = 'WfCarouselWidget';

WfCarouselWidget.defaultProps = {
    reviewsLimit: 3
};

var mapStateToProps = function mapStateToProps(_ref2) {
    var wfCarousel = _ref2.wfCarousel;

    return {
        averageRating: +wfCarousel.widget.average_rating,
        totalReviews: wfCarousel.widget.total_reviews,
        profileType: wfCarousel.widget.profileType,
        profileId: wfCarousel.widget.profileId,
        baseUrl: wfCarousel.widget.baseUrl,
        reviews: wfCarousel.widget.reviews,
        link: wfCarousel.widget.link,
        offset: wfCarousel.widget.offset,
        reviewsLimit: wfCarousel.widget.reviewsLimit,
        responsiveId: wfCarousel.widget.responsiveId,
        bodyStyle: wfCarousel.widget.bodyStyle,
        showProfileImageInReview: wfCarousel.widget.showProfileImageInReview,
        reviewItemBackground: wfCarousel.widget.reviewItemBackground,
        reviewItemFrame: wfCarousel.widget.reviewItemFrame,
        wrapperFrame: wfCarousel.widget.wrapperFrame,
        minReviewRating: wfCarousel.widget.minReviewRating
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        next: function next(props) {
            var profileId = props.profileId,
                profileType = props.profileType;

            var newOffset = props.offset + props.reviewsLimit;
            if (newOffset < props.totalReviews) {
                return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(newOffset)), dispatch(_widgetActions.widgetActions.loadReviews(profileId, profileType, props.reviewsLimit, newOffset, props.minReviewRating))]);
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        },
        prev: function prev(props) {
            var profileId = props.profileId,
                profileType = props.profileType;

            var newOffset = props.offset - props.reviewsLimit;
            if (newOffset >= 0) {
                return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(newOffset)), dispatch(_widgetActions.widgetActions.loadReviews(profileId, profileType, props.reviewsLimit, newOffset, props.minReviewRating))]);
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        },
        resize: function resize(reviewsLimit, props) {
            dispatch(_widgetActions.widgetActions.changeLimit(reviewsLimit));
            if (reviewsLimit > props.reviews.length) {
                var profileId = props.profileId,
                    profileType = props.profileType,
                    offset = props.offset;

                return dispatch(_widgetActions.widgetActions.loadReviews(profileId, profileType, reviewsLimit, offset, props.minReviewRating));
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WfCarouselWidget);